import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'

const mapResourcesToPanel = (props, context) => ({
  app: '/api/admin/apps/finance/settings'
})

const mapPropsToPanel = (props, context) => ({
  title: 't(Bank Accounts)',
  collection: {
    endpoint: '/api/admin/platform/banks',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true },
      { label: 't(Team)', key: 'team.title', sort: 'team', primary: true },
      { label: 't(Status)', key: 'status', collapsing: true, primary: true, format: StatusToken  }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/platform/banks/${record.id}`),
    empty: {
      icon: 'university',
      title: 't(No Bank Accounts)',
      text: 't(You have not yet added any bank accounts)'
    },
    entity: 'invoice'
  }
})

export default Panel(mapResourcesToPanel, mapPropsToPanel)
